'use client';

import { Cookie } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslations } from '@/hooks/useTranslations';
import { useCookieConsent } from '@/hooks/useCookieConsent';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export function CookieBanner() {
  const t = useTranslations('CookieBanner');
  const { status, accept, decline } = useCookieConsent();
  const pathname = usePathname();
  const locale = pathname.split('/')[1] || 'en';

  if (status !== 'pending') return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background border-t shadow-lg">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie className="w-5 h-5 shrink-0 text-emerald-600 dark:text-emerald-400 mt-0.5 sm:mt-0" />

        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">{t('title')}</p>
          <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">
            {t('description')}{' '}
            <Link
              href={`/${locale}/privacy`}
              className="underline underline-offset-2 hover:text-foreground transition-colors"
            >
              {t('learnMore')}
            </Link>
          </p>
        </div>

        <div className="flex gap-2 shrink-0">
          <Button variant="outline" size="sm" onClick={decline}>
            {t('decline')}
          </Button>
          <Button size="sm" onClick={accept}>
            {t('accept')}
          </Button>
        </div>
      </div>
    </div>
  );
}
